import { render, staticRenderFns } from "./LayoutSecured.vue?vue&type=template&id=03cd2e65&scoped=true&"
import script from "./LayoutSecured.vue?vue&type=script&lang=js&"
export * from "./LayoutSecured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cd2e65",
  null
  
)

export default component.exports